/*
  Geo fallback for the Tavola buttons.

  The market a shopper has selected is handled in Liquid ('tavola-link'), which
  is flash-free and needs no JavaScript. This file covers the other case: the
  shopper is physically in a Tavola country but is browsing a different market,
  either because they switched the country selector or because the store did not
  redirect them.

  It asks Shopify where the request came from, and if that is one of the Tavola
  countries it hides the add to cart / buy now controls and reveals the deferred
  button that Liquid already rendered next to them.

  Config comes from 'tavola-geo-js.liquid' as window.tavolaGeo.
*/
(function () {
  var config = window.tavolaGeo;
  if (!config || !config.enabled) return;

  // Liquid already swapped the buttons for the selected market - nothing to do.
  if (config.serverApplied) return;

  var CACHE_KEY = 'tavola:country';
  var HTML = document.documentElement;

  function urlFor(code) {
    return code && config.markets ? config.markets[code] : null;
  }

  // Swap the announcement bar over to the message for the detected country.
  // Rewriting the first announcement in place keeps the slider's item count
  // stable, which building extra markup would not.
  function applyNotice(code) {
    var notice = config.notices ? config.notices[code] : null;
    if (!notice) return;

    var items = document.querySelectorAll('.announcements-bar .announcement');
    if (!items.length) return;

    // Mark it before writing, so the per-country announcement script in
    // theme.liquid stands down whichever order the two happen to run in.
    items[0].setAttribute('data-tavola-notice', '');

    var first = items[0].querySelector('p') || items[0];
    first.textContent = notice;

    for (var i = 1; i < items.length; i++) {
      items[i].classList.add('tavola-hidden');
    }
  }

  function apply(code) {
    var url = urlFor(code);
    if (!url) return;

    HTML.classList.add('tavola-geo');
    applyNotice(code);

    document.querySelectorAll('[data-tavola-deferred]').forEach(function (el) {
      el.setAttribute('href', url);
      el.removeAttribute('hidden');
    });

    // These already know where they point (the store locator), so only reveal.
    document.querySelectorAll('[data-tavola-deferred-link]').forEach(function (el) {
      el.removeAttribute('hidden');
    });

    document.querySelectorAll('[data-tavola-swap-hide]').forEach(function (el) {
      el.classList.add('tavola-hidden');
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Shopify reports the country it detected for this request. Shapes have
  // varied across versions, so read the code defensively.
  function detectedCountry(payload) {
    var detected = payload && payload.detected_values;
    var country = detected && detected.country;
    if (!country) return null;
    var code = country.handle || country.iso_code || country.code;
    return code ? String(code).toUpperCase() : null;
  }

  var cached = null;
  try {
    cached = sessionStorage.getItem(CACHE_KEY);
  } catch (e) {
    // Private browsing or blocked storage - fall through to the network call.
  }

  if (cached) {
    onReady(function () {
      apply(cached);
    });
    return;
  }

  var root = (window.routes && window.routes.root) || '/';
  var endpoint = root.replace(/\/$/, '') + '/browsing_context_suggestions.json';

  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (payload) {
      var code = detectedCountry(payload);
      if (!code) return;

      try {
        sessionStorage.setItem(CACHE_KEY, code);
      } catch (e) {
        // Not being able to cache only costs us a repeat request.
      }

      onReady(function () {
        apply(code);
      });
    })
    .catch(function () {
      // Geo is a fallback on top of the market rule. If it fails the shopper
      // keeps the normal buttons for the market they are actually browsing.
    });
})();
